import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import notificationHistoryEndpoints, {
  notificationHistoryUrl,
} from 'SharedDir/backend/endpoints/notification-history';
import { NNotificationHistory } from 'SharedDir/declarations/notification-history';

import SimpleApi from './simpleApi';

export default class NotificationHistoryApiClass extends SimpleApi<
  NNotificationHistory.NotificationHistory,
  NNotificationHistory.NotificationHistory
> {
  private readonly endpoints = notificationHistoryEndpoints;

  constructor() {
    super(notificationHistoryUrl);
  }

  /**
   * Повтор той же записи. Бэк не создаёт новое уведомление.
   */
  public async resend(notificationId: string, messageId: string) {
    const { data } = (await http(
      this.endpoints.RESEND(notificationId, messageId)
    )) as AxiosResponse<NNotificationHistory.NotificationHistory>;

    return data;
  }
}
